import AuthFail from './AuthFail';
export default AuthFail;
